<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-4-desktop is-12-tablet">
        <p class="title is-size-4 has-text-centered">價格維護</p>
        <table class="table is-bordered is-narrow">
          <thead>
            <tr>
              <th class="has-text-centered" style="width: 150px;">欄位</th>
              <th class="has-text-centered">修改前</th>
              <th class="has-text-centered">修改後</th>
            </tr>
          </thead>
          <tbody>
            <tr :class="rowClass(origin.deposit, modified.deposit)">
              <td>{{ $t('attributes.deposit') }}</td>
              <td>{{ origin.deposit }}</td>
              <td>{{ modified.deposit }}</td>
            </tr>

            <tr :class="rowClass(origin.tip_flag, modified.tip_flag)">
              <td>{{ $t('attributes.tip_included') }}</td>
              <td>{{ includedFlag(origin.tip_flag === 'Y') }}</td>
              <td>{{ includedFlag(modified.tip_flag === 'Y') }}</td>
            </tr>
            <tr :class="rowClass(origin.tip_fee, modified.tip_fee)">
              <td>{{ $t('attributes.tip_fee') }}</td>
              <td>{{ origin.tip_fee }}</td>
              <td>{{ modified.tip_fee }}</td>
            </tr>

            <tr
              :class="rowClass(origin.insurance_flag, modified.insurance_flag)"
            >
              <td>{{ $t('attributes.tax_included') }}</td>
              <td>{{ includedFlag(origin.insurance_flag === 'Y') }}</td>
              <td>{{ includedFlag(modified.insurance_flag === 'Y') }}</td>
            </tr>
            <tr :class="rowClass(origin.insurance_fee, modified.insurance_fee)">
              <td>{{ $t('attributes.tax_fee') }}</td>
              <td>{{ origin.insurance_fee }}</td>
              <td>{{ modified.insurance_fee }}</td>
            </tr>

            <tr :class="rowClass(origin.visa_flag, modified.visa_flag)">
              <td>{{ $t('attributes.visa_included') }}</td>
              <td>{{ visaFlag(origin.visa_flag) }}</td>
              <td>{{ visaFlag(modified.visa_flag) }}</td>
            </tr>
            <tr :class="rowClass(origin.visa_fee, modified.visa_fee)">
              <td>{{ $t('attributes.visa_fee') }}</td>
              <td>{{ origin.visa_fee }}</td>
              <td>{{ modified.visa_fee }}</td>
            </tr>

            <tr :class="rowClass(origin.hide_price, modified.hide_price)">
              <td>{{ $t('attributes.hide_price') }}</td>
              <td>{{ displayStatus(origin.hide_price === 'N') }}</td>
              <td>{{ displayStatus(modified.hide_price === 'N') }}</td>
            </tr>
            <tr :class="rowClass(origin.show_up, modified.show_up)">
              <td>{{ $t('attributes.show_up') }}</td>
              <td>{{ whetherStatus(origin.show_up === 'Y') }}</td>
              <td>{{ whetherStatus(modified.show_up === 'Y') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="column is-8-desktop is-12-tablet">
        <p class="title is-size-4 has-text-centered">價格進階維護</p>
        <div class="columns is-multiline">
          <div
            v-for="idx in travelers"
            :key="idx"
            class="column is-6-desktop is-12-tablet"
          >
            <table class="table is-bordered is-narrow">
              <thead>
                <tr
                  :class="{
                    'has-background-danger-light':
                      !origin.traveler_types[idx] ||
                      !modified.traveler_types[idx]
                  }"
                >
                  <th class="has-text-centered" style="width: 150px;">欄位</th>
                  <th class="has-text-centered">修改前</th>
                  <th class="has-text-centered">修改後</th>
                </tr>
              </thead>

              <tbody
                v-if="
                  origin.traveler_types[idx] && modified.traveler_types[idx]
                "
              >
                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].sort,
                      modified.traveler_types[idx].sort
                    )
                  "
                >
                  <td>{{ $t('attributes.sort') }}</td>
                  <td>{{ origin.traveler_types[idx].sort }}</td>
                  <td>{{ modified.traveler_types[idx].sort }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].name,
                      modified.traveler_types[idx].name
                    )
                  "
                >
                  <td>{{ $t('attributes.name') }}</td>
                  <td>{{ origin.traveler_types[idx].name }}</td>
                  <td>{{ modified.traveler_types[idx].name }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].type,
                      modified.traveler_types[idx].type
                    )
                  "
                >
                  <td>{{ $t('attributes.traveler_bed_type') }}</td>
                  <td>{{ bedTypeName(origin.traveler_types[idx].type) }}</td>
                  <td>{{ bedTypeName(modified.traveler_types[idx].type) }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].age_min,
                      modified.traveler_types[idx].age_min
                    )
                  "
                >
                  <td>{{ $t('attributes.age_min') }}</td>
                  <td>{{ origin.traveler_types[idx].age_min }}</td>
                  <td>{{ modified.traveler_types[idx].age_min }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].age_max,
                      modified.traveler_types[idx].age_max
                    )
                  "
                >
                  <td>{{ $t('attributes.age_max') }}</td>
                  <td>{{ origin.traveler_types[idx].age_max }}</td>
                  <td>{{ modified.traveler_types[idx].age_max }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].price,
                      modified.traveler_types[idx].price
                    )
                  "
                >
                  <td>{{ $t('attributes.price') }}</td>
                  <td>{{ origin.traveler_types[idx].price }}</td>
                  <td>{{ modified.traveler_types[idx].price }}</td>
                </tr>

                <tr
                  :class="
                    rowClass(
                      origin.traveler_types[idx].display_flag,
                      modified.traveler_types[idx].display_flag
                    )
                  "
                >
                  <td>{{ $t('attributes.want_display') }}</td>
                  <td>
                    {{ displayStatus(origin.traveler_types[idx].display_flag) }}
                  </td>
                  <td>
                    {{
                      displayStatus(modified.traveler_types[idx].display_flag)
                    }}
                  </td>
                </tr>
              </tbody>

              <tbody
                v-else-if="origin.traveler_types[idx]"
                class="has-text-danger has-text-weight-bold has-background-danger-light"
              >
                <tr>
                  <td>{{ $t('attributes.sort') }}</td>
                  <td>{{ origin.traveler_types[idx].sort }}</td>
                  <td rowspan="7" class="has-text-centered">刪除</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.name') }}</td>
                  <td>{{ origin.traveler_types[idx].name }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.traveler_bed_type') }}</td>
                  <td>{{ bedTypeName(origin.traveler_types[idx].type) }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.age_min') }}</td>
                  <td>{{ origin.traveler_types[idx].age_min }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.age_max') }}</td>
                  <td>{{ origin.traveler_types[idx].age_max }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.price') }}</td>
                  <td>{{ origin.traveler_types[idx].price }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.want_display') }}</td>
                  <td>
                    {{ displayStatus(origin.traveler_types[idx].display_flag) }}
                  </td>
                </tr>
              </tbody>

              <tbody
                v-else-if="modified.traveler_types[idx]"
                class="has-text-danger has-text-weight-bold has-background-danger-light"
              >
                <tr>
                  <td>{{ $t('attributes.sort') }}</td>
                  <td rowspan="7" class="has-text-centered">新增</td>
                  <td>{{ modified.traveler_types[idx].sort }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.name') }}</td>
                  <td>{{ modified.traveler_types[idx].name }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.traveler_bed_type') }}</td>
                  <td>{{ bedTypeName(modified.traveler_types[idx].type) }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.age_min') }}</td>
                  <td>{{ modified.traveler_types[idx].age_min }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.age_max') }}</td>
                  <td>{{ modified.traveler_types[idx].age_max }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.price') }}</td>
                  <td>{{ modified.traveler_types[idx].price }}</td>
                </tr>

                <tr>
                  <td>{{ $t('attributes.want_display') }}</td>
                  <td>
                    {{
                      displayStatus(modified.traveler_types[idx].display_flag)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductPriceDetail',

  props: {
    origin: {
      type: Object,
      required: true
    },
    modified: {
      type: Object,
      required: true
    }
  },
  data() {
    const originCount = this.origin.traveler_types
      ? this.origin.traveler_types.length
      : 0
    const modifiedCount = this.modified.traveler_types
      ? this.modified.traveler_types.length
      : 0
    const travelerCount = Math.max(originCount, modifiedCount)

    return {
      travelers: [...Array(travelerCount).keys()]
    }
  },
  methods: {
    rowClass(before, after) {
      if (before !== after) {
        return 'has-text-danger has-text-weight-bold has-background-danger-light'
      } else {
        return ''
      }
    }
  }
}
</script>
